export default "__VITE_ASSET__d039030b__"